import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

export interface SpinnerProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  className?: string;
}

const Spinner = ({ size = 24, className }: SpinnerProps) => {
  return <Loader2 size={size} className={cn('animate-spin text-primary/80', className)} />;
};

export default Spinner;
